<div (keyup.escape)="close()" [class.show]="show$ | async" tabindex="0" class="search">
  <button
    (click)="close()" (keydown.enter)="close()"
    [attr.aria-label]="'shared.common.close' | translate"
    class="ltr:right-12 rtl:left-12 top-12 absolute"
    color="primary"
    mat-icon-button
    type="button">
    <mat-icon svgIcon="mat:close"></mat-icon>
  </button>

  <input
    #searchInput
    (keyup.enter)="search()"
    [formControl]="searchCtrl"
    class="search-input"
    [placeholder]="'shared.toolbarSearch.placeholder' | translate" />
  <div class="search-hint">{{ 'shared.toolbarSearch.hint' | translate }}</div>
</div>

@if (show$ | async) {
  <div (click)="close()" (keydown.enter)="close()" class="search-overlay" tabindex="0"></div>
}
